export default function createSiteReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_SITE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_SITE_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_SITE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}